<template>
  <div v-if="parentEntity && !selectedData && dataPagination && dataPagination.docs.length > 0" class="mt-3">
    <right-panel class="float-right" id="sidebar-new-datasource-datasubject" width="600px" icon="" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form />
      </div>
    </right-panel>
    <right-panel class="float-right" id="sidebar-info-datasubject" width="800px">
      <div class="pl-5 pr-5" v-if="infoItem">
        <h3 class="mb-5">
          <i class="bx bx-info-circle align-middle font-size-24 mr-2"></i>
          <span class="  text-primary">{{ infoItem.name | translate }}</span>

          {{ $t("datasubject.info") }}
        </h3>

        <content-loading v-if="isInfoLoading" />
        <div v-else>
          <h5>{{ $t("datasubject.used-places") }}</h5>
          <table v-if="info && info.docs.length > 0" class="table table-border table-striped">
            <thead class="bg-dark text-white">
              <tr>
                <th>{{ $t("department.text") }}</th>
                <th>{{ $t("process.text") }}</th>
                <th>{{ $t("datasource.text") }}</th>
                <th>{{ $t("data.text") }}</th>
                <th class="text-center">{{ $t("common.edit") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in info.docs" :key="'info' + i._id">
                <td>
                  {{ i.department.name | translate }}
                </td>
                <td>
                  {{ i.process.name | translate }}
                </td>
                <td>
                  {{ i.datasource.name | translate }}
                </td>
                <td>{{ i.name | translate }}</td>
                <td style="text-align: center;">
                  <a href="javascript:;void(0);" @click="deleteByIdFromHierarchy(i)" v-b-tooltip.hover :title="$t('common.delete')">
                    <i class="bx bx-trash-alt text-danger"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
          <empty v-else width="200px">
            <h6 class="text-center">{{ $t("common.no-hierarchy") }}</h6>
          </empty>
        </div>
        <!-- Begin: Pagination -->

        <div v-if="info" class="row">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="infoRequest.options.page" :total-rows="info.totalDocs" :per-page="info.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
        <!-- End: Pagination -->
      </div>
    </right-panel>

    <div class="ds-card">
      <div class="ds-card--title justify-content-between">
        <span>
          <i class="iconoir-center-align align-middle mr-3" style="color: #383A55; font-size: 1.5rem !important;"></i>
          <span
            v-html="
              $t('datasubject.owned-list-datasource', {
                department: $options.filters.translate(breadCrumbs.process.department.name),
                process: $options.filters.translate(breadCrumbs.process.name),
                datasource: $options.filters.translate(breadCrumbs.datasource.name),
              })
            "
          >
          </span>
        </span>

        <div v-if="recommendationAvailable" class="d-flex align-items-center float-right">
          <div class="d-flex align-items-center">
            <label class="switch-label">{{ $t("common.recommendations") }}</label>
            <b-form-checkbox v-model="showRecommendationBoxes" name="check-button" switch class="switch"></b-form-checkbox>
          </div>
        </div>
      </div>
      <div>
        <div class="search2  mb-4" style=" width: 18.50rem;">
          <div class="search2--icon"><i class="iconoir-search"></i></div>
          <input class="search2--input" type="text" :placeholder="$t('common.search')" v-model="nameFilter" />
        </div>
      </div>

      <content-loading v-if="isLoading" />
      <div v-else-if="pagination" class="d-flex" style="gap: 1.25rem;flex-wrap: wrap;">
        <div v-for="item in pagination.docs" :key="item._id" class="ds-card--item" :class="selectedBoxStyle(item)" @click="selectBox(item)">
          <div class="text">{{ item.name | translate }}</div>
          <div class="actions d-flex justify-content-center">
            <div class="action" v-if="hasRemovePermission" @click="deleteById(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.delete')">
              <i class="iconoir-trash"></i>
            </div>
            <div class="action" @click="fetchInfo(item)" v-on:click.stop v-b-toggle="'sidebar-info-datasubject'" v-b-tooltip.hover :title="$t('datasubject.used-places')">
              <i class="iconoir-info-circle"></i>
            </div>

            <div class="action" @click="edit(item)" v-on:click.stop v-b-tooltip.hover :title="$t('common.edit')">
              <i class="iconoir-edit-pencil"></i>
            </div>
          </div>
        </div>

        <div class="ds-card--item2" @click="openRightPanel">
          <i class="iconoir-plus" style="font-size: 1.75rem;"></i>
        </div>
      </div>

      <!-- Begin: Pagination -->

      <div v-if="pagination" class="row mt-4">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->

      <recommendation-boxes
        v-if="parentEntity"
        :id="parentEntity._id"
        :show="showRecommendationBoxes"
        :level="libraryScopedState"
        libraryScopedState="organizationDatasourceDatasubject"
        organizationScopedState="organizationDatasourceDatasubject"
        @interceptForSetParent="interceptForSetParent"
        @onAccepted="paginate"
        @copyToForm="copyToForm"
      />
    </div>
  </div>
</template>

<script>
import Form from "../../data-datasubject/organization-datasource-datasubject-form.vue";
import RecommendationBoxes from "./recommendation-boxes";

export default {
  components: { Form, RecommendationBoxes },
  data() {
    return {
      request: {
        options: { page: 1, limit: 17, sort: { name: "asc" } },
        query: {},
      },
      nameFilter: undefined,
      libraryScopedState: "organizationDatasourceDatasubject",
      showRecommendationBoxes: undefined,

      infoRequest: {
        options: { page: 1, limit: 10, sort: { name: "asc" } },
        query: {},
      },
    };
  },
  computed: {
    recommendationAvailable() {
      const loading = this.$store.getters[`${this.libraryScopedState}/isLoading`];
      const recommendations = this.$store.getters[`${this.libraryScopedState}/recommendations`];

      if (loading) {
        return false;
      }
      if (recommendations && recommendations.docs && recommendations.docs.length > 0) {
        return true;
      }
      return false;
    },
    parentEntity() {
      return this.$store.getters["entityBoxes/datasource"];
    },

    selectedData() {
      return this.$store.getters["entityBoxes/data"];
    },
    breadCrumbs() {
      return {
        ...this.$store.getters["entityBoxes/data"],
        department: this.$store.getters["entityBoxes/department"],
        process: this.$store.getters["entityBoxes/process"],
        datasource: this.$store.getters["entityBoxes/datasource"],
      };
    },
    pagination() {
      return this.$store.getters["organizationDatasourceDatasubject/pagination"];
    },
    dataPagination() {
      return this.$store.getters["organizationDatasourceData/pagination"];
    },
    isLoading() {
      return this.$store.getters["organizationDatasourceDatasubject/isLoading"];
    },

    hasUpdatePermission() {
      return true;
    },
    hasRemovePermission() {
      return true;
    },

    infoItem() {
      return this.$store.getters["organizationDatasubject/infoItem"];
    },
    info() {
      return this.$store.getters["organizationDatasubject/info"];
    },
    isInfoLoading() {
      return this.$store.getters["organizationDatasubject/isInfoLoading"];
    },
  },
  watch: {
    async nameFilter(n, o) {
      this.debounce(() => this.handleNameFilterChanged(n, o));
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    parentEntity(item) {
      this.debounce(() => this.paginate());
    },

    infoRequest: {
      deep: true,
      immediate: false,
      handler() {
        this.debounce(() => this.fetchInfo());
      },
    },
  },
  mounted() {},
  methods: {
    async handleNameFilterChanged(n, o) {
      this.$store.commit("entityBoxes/clearFrom", "datasubject");
      this.$store.commit("organizationDatasourceDatasubject/selectedEntity", undefined);

      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };

        const selectedDatasubject = this.$store.getters["entityBoxes/datasource"];
        if (selectedDatasubject) {
          await this.selectBox(selectedDatasubject);
        }
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
    selectedBoxStyle(item) {
      if (this.$store.getters["entityBoxes/datasubject"]?._id == item._id) {
        return "bg-main text-white";
      }
    },

    async paginate(item) {
      if (!this.parentEntity) {
        return;
      }
      const request = { ...this.request };
      request.query = {
        ...request.query,
        datasource: { value: { _id: this.parentEntity._id }, isObject: true },
      };

      await this.$store.dispatch("organizationDatasourceDatasubject/paginateForDatasource", { pagination: request, processDatasourceId: this.parentEntity._id });
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDatasourceDatasubject/delete", { datasourceId: this.parentEntity._id, datasubjectId: item._id });
        this.paginate();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' Silindi");
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: "'" + this.$options.filters.translate(item.name) + "' Silinemedi" });
      }
    },

    interceptForSetParent(payload) {
      payload.datasource = this.parentEntity;
    },

    async deleteByIdFromHierarchy(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationDataDatasubject/delete", item.rel_id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.fetchInfo();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error, { customMessage: this.$t("common.delete-failed") });
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.$store.dispatch("organizationDatasourceDatasubject/resetForm");
      this.$store.commit(`organizationDatasourceDatasubject/selectedEntity`, null);
    },

    selectBox(item) {
      this.$store.dispatch("entityBoxes/selectDatasubject", item);
    },

    fetchInfo(item) {
      if (!item) {
        item = this.infoItem;
      }
      this.$store.dispatch("organizationDatasubject/fetchInfo", { item, pagination: this.infoRequest });
    },

    openRightPanel() {
      const datasource = this.$store.getters["entityBoxes/datasource"];
      this.$store.commit(`organizationDatasourceDatasubject/selectedEntity`, datasource);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-datasubject");
    },

    copyToForm(item) {
      this.$store.commit(`organizationDatasourceDatasubject/copingEntity`, { ...item, libraryItem: item, _id: undefined, datasource: this.parentEntity });
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-datasubject");
    },

    edit(item) {
      this.$store.commit("organizationDatasourceDatasubject/editedEntity", item);
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-datasource-datasubject");
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../organization-entities-view.scss");
</style>
